var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',[_vm._t("default"),_vm._v(" "),_c(_setup.ModalsContainer)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }